module.exports = __webpack_public_path__ + "img/nature_zitrone_2_new.89d80a70.jpg";